export default __webpack_public_path__ + "89f787a2ad8f04c87aa3def9ae53ae8c.jpg";